var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M99.933,196.158c-53.411,0-96.862-43.448-96.862-96.858S46.522,2.44,99.933,2.44 c53.408,0,96.859,43.45,96.859,96.86S153.341,196.158,99.933,196.158L99.933,196.158z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9307,
    y1: 4.3877,
    x2: 99.9307,
    y2: 194.2124
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2843,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    style: {
      stopColor: "#5D5B5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    style: {
      stopColor: "#959394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7767,
    style: {
      stopColor: "#2B2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M99.932,194.212c-52.334,0-94.913-42.579-94.913-94.912c0-52.335,42.578-94.913,94.913-94.913 c52.333,0,94.911,42.578,94.911,94.913C194.843,151.633,152.265,194.212,99.932,194.212L99.932,194.212z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.4526,
    y1: 93.771,
    x2: 82.9598,
    y2: 5.9067
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2893,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6599,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M131.284,60.151c20.813,0,40.581,2.952,58.393,8.256c-12.844-37.214-48.222-64.02-89.745-64.02 C47.597,4.388,5.019,46.965,5.019,99.3c0,3.665,0.217,7.278,0.623,10.835C29.42,80.415,76.758,60.151,131.284,60.151z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.932,186.415c-47.498,0-86.142-38.642-86.142-86.14c0-47.497,38.644-86.139,86.142-86.139 s86.139,38.643,86.139,86.139C186.07,147.773,147.43,186.415,99.932,186.415L99.932,186.415z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9307,
    y1: 184.4668,
    x2: 99.9307,
    y2: 14.1343
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1218,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3503,
    style: {
      stopColor: "#7E7F80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M99.932,184.467c-46.959,0-85.167-38.207-85.167-85.165c0-46.96,38.207-85.168,85.167-85.168 c46.96,0,85.164,38.208,85.164,85.168C185.096,146.26,146.892,184.467,99.932,184.467L99.932,184.467z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.9751,
    y1: 102.8555,
    x2: 84.5754,
    y2: 15.5192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1218,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3706,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M178.357,66.1C165.39,35.588,135.12,14.134,99.932,14.134c-46.959,0-85.167,38.208-85.167,85.168 c0,0.576,0.011,1.15,0.023,1.724c14.704,3.398,30.512,5.253,46.979,5.253C110.061,106.278,152.713,90.383,178.357,66.1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#352612",
    d: "M99.933,176.669c-42.663,0-77.372-34.709-77.372-77.369c0-42.661,34.708-77.37,77.372-77.37 c42.659,0,77.368,34.709,77.368,77.37C177.301,141.96,142.592,176.669,99.933,176.669L99.933,176.669z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: 99.9307,
    cy: 99.3008,
    r: 75.4189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F05151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6954,
    style: {
      stopColor: "#F05151"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7334,
    style: {
      stopColor: "#F04F4F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7678,
    style: {
      stopColor: "#F04A48"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8008,
    style: {
      stopColor: "#EF413D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8327,
    style: {
      stopColor: "#EE342F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8579,
    style: {
      stopColor: "#ED2224"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9391,
    style: {
      stopColor: "#AF1F24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D1416"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "url(#SVGID_5_)",
    cx: 99.931,
    cy: 99.3,
    r: 75.419
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.9775,
    y1: 22.1714,
    x2: 57.2469,
    y2: 71.5959,
    gradientTransform: "matrix(0.8913 -0.565 0.5354 0.8446 2.354 57.9621)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1175,
    style: {
      stopColor: "#FDE3DB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4373,
    style: {
      stopColor: "#F8A597"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7012,
    style: {
      stopColor: "#F37B6E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8958,
    style: {
      stopColor: "#F15E58"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05151"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M122.912,43.311c7.285,11.494-8.656,28.319-32.072,43.163 c-23.415,14.842-45.434,22.083-52.72,10.588c-7.286-11.493,2.921-37.368,26.336-52.21C87.87,30.009,115.625,31.817,122.912,43.311z "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 85.6953,
    y1: 139.7217,
    x2: 115.4178,
    y2: 204.1106,
    gradientTransform: "matrix(-0.8169 0.5767 -0.5767 -0.8169 302.0685 206.8574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEF2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1628,
    style: {
      stopColor: "#FBCFCB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3507,
    style: {
      stopColor: "#F8ADA8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    style: {
      stopColor: "#F69490"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7064,
    style: {
      stopColor: "#F48280"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8662,
    style: {
      stopColor: "#F37777"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F37374"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M72.701,154.774c-9.177-12.996,7.336-32.773,32.425-50.485 c25.089-17.713,49.253-26.654,58.429-13.657c9.175,12.997-0.114,43.007-25.203,60.719 C113.262,169.065,81.874,167.771,72.701,154.774z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.8911,
    y1: 142.4014,
    x2: 103.5443,
    y2: 200.1852,
    gradientTransform: "matrix(-0.8169 0.5767 -0.5767 -0.8169 302.0685 206.8574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA1E22"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0039,
    style: {
      stopColor: "#AA1E23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2952,
    style: {
      stopColor: "#C43333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5671,
    style: {
      stopColor: "#D94242"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8102,
    style: {
      stopColor: "#E84D4D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F05151"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M70.558,153.061c-9.176-12.995,7.335-32.774,32.425-50.487 c25.092-17.712,49.254-26.651,58.43-13.655c9.175,12.996-0.113,43.007-25.201,60.719C111.12,167.353,79.732,166.058,70.558,153.061 z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M139.595,55.924c-0.803,1.058-7.928-3.067-16.953-7.406c-8.996-4.395-16.72-7.445-16.391-8.729 c0.29-1.244,8.955-0.138,18.447,4.487C134.211,48.86,140.387,54.927,139.595,55.924z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153.961,68.468c-0.776,0.724-3.545-0.979-6.384-3.569c-2.833-2.598-4.757-5.188-4.105-6.025 c0.646-0.833,3.729,0.487,6.689,3.198C153.126,64.777,154.732,67.75,153.961,68.468z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.844,98.489L52.498,52.644h30.393l16.9,26.254l17.036-26.254h29.711l-31.347,45.578l32.71,47.711h-30.393l-18.264-28.12 l-18.399,28.12H51.134L83.844,98.489z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.37111db87236ced370749e9f27b60acf.svg";
export { ForwardRef as ReactComponent };